import React from 'react';
import { TooltipState } from './types';

export const TooltipContext = React.createContext<TooltipState | null>(null);
